import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import WhyChooseUs from './components/WhyChooseUs';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import AboutUs from './components/AboutUs';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/c925375f38344b4ce5e0a3111721797b.png" 
              alt="Masaje de Vida" 
              className={`h-12 w-auto transition-all duration-300 ${
                isScrolled ? '' : 'brightness-0 invert'
              }`}
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#servicios"
              className={`text-sm tracking-wider uppercase transition-colors ${
                isScrolled ? 'text-[#2C3E2F] hover:text-[#A8B5A0]' : 'text-white hover:text-[#A8B5A0]'
              }`}
            >
              Servicios
            </a>
            <a
              href="#sobre-nosotros"
              className={`text-sm tracking-wider uppercase transition-colors ${
                isScrolled ? 'text-[#2C3E2F] hover:text-[#A8B5A0]' : 'text-white hover:text-[#A8B5A0]'
              }`}
            >
              Sobre Nosotros
            </a>
            <a
              href="#contacto"
              className={`text-sm tracking-wider uppercase transition-colors ${
                isScrolled ? 'text-[#2C3E2F] hover:text-[#A8B5A0]' : 'text-white hover:text-[#A8B5A0]'
              }`}
            >
              Contacto
            </a>
            <a
              href="tel:643218449"
              className={`px-6 py-2 rounded-full border-2 transition-all whitespace-nowrap ${
                isScrolled
                  ? 'border-[#A8B5A0] text-[#2C3E2F] hover:bg-[#A8B5A0] hover:text-white'
                  : 'border-white text-white hover:bg-white hover:text-[#2C3E2F]'
              }`}
            >
              <i className="ri-phone-line mr-2"></i>
              643 218 449
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`md:hidden ${isScrolled ? 'text-[#2C3E2F]' : 'text-white'}`}
            onClick={() => {
              const menu = document.getElementById('mobile-menu');
              menu?.classList.toggle('hidden');
            }}
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div id="mobile-menu" className="hidden md:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-4">
            <a href="#servicios" className="block text-[#2C3E2F] hover:text-[#A8B5A0]">
              Servicios
            </a>
            <a href="#sobre-nosotros" className="block text-[#2C3E2F] hover:text-[#A8B5A0]">
              Sobre Nosotros
            </a>
            <a href="#contacto" className="block text-[#2C3E2F] hover:text-[#A8B5A0]">
              Contacto
            </a>
            <a
              href="tel:643218449"
              className="block px-6 py-2 rounded-full border-2 border-[#A8B5A0] text-[#2C3E2F] text-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              643 218 449
            </a>
          </div>
        </div>
      </nav>

      <Hero />
      <WhyChooseUs />
      <Services />
      <Testimonials />
      <AboutUs />
      <FAQ />
      <CTASection />
      <Footer />

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/34667459830"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 cursor-pointer"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </a>
    </div>
  );
}
